export default {
  methods: {
    goToPage(opt) {
      this.$router.push(opt)
    },
    goBack() {
      let isFirst = this.$route.meta.isFirst
      if (isFirst) {
        this.$router.replace({ name: 'home' })
        this.$route.meta.isFirst = false
      } else {
        this.$router.go(-1)
      }
    },
    reload() {
      this.$router.go(0)
    }
  }
}